import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import MqttReducer from '@iso/redux/mqtt/reducer';
import Dashboard from '@iso/redux/dashboard/reducer';
import Widgets from '@iso/redux/widgets/reducer';
import Merchant from '@iso/redux/merchant/reducer';
import Monitoring from '@iso/redux/monitoring/reducer';
import AccountOfficer from '@iso/redux/account_officer/reducer';
import Tools from '@iso/redux/tools/reducer';
import Transaction from '@iso/redux/transactions/reducer';
import Onboarding from '@iso/redux/onboarding/reducer';
import Settlement from '@iso/redux/settlement/reducer';
import Finance from '@iso/redux/finance/reducer';
import Files from '@iso/redux/files/reducer';
import Notes from '@iso/redux/notes/reducer';
import AuditLogs from '@iso/redux/auditLogs/reducer'

export default combineReducers({
  AccountOfficer,
  Auth,
  App,
  Dashboard,
  Finance,
  LanguageSwitcher,
  Merchant,
  Monitoring,
  MqttReducer,
  ThemeSwitcher,
  Tools,
  Transaction,
  Widgets,
  Onboarding,
  Settlement,
  Files,
  Notes,
  AuditLogs
});
